import React from 'react';
import {StyleSheet} from 'react-native';

import {colors} from '../../styles';
import {Text, TextProps} from '../Typography';

export const ErrorMessage: React.FC<TextProps> = ({style, ...props}) => (
  <Text variant="s" style={[styles.text, style]} {...props} />
);

const styles = StyleSheet.create({
  text: {
    color: colors.vividRed,
    textAlign: 'center',
  },
});
